const {
  VITE_COMPANION_CLIENT_ID: COMPANION_CLIENT_ID,
  VITE_COMPANION_APP_CLIENT_ID: COMPANION_APP_CLIENT_ID,
} = import.meta.env

export const getIsApp = () => {
  const platform = window.location.search.toLowerCase().includes('platform')
  const authV2 = window.location.search.toLowerCase().includes('auth')
  let isApp = false
  if (!authV2) {
    isApp =
      /\/(callbacksigninapp|onboarding|macos-onboarding)/.test(
        window.location.pathname.toLowerCase(),
      ) || platform
  }

  return isApp
}

export const getClientId = () => {
  const isApp = getIsApp()
  return isApp
    ? (COMPANION_APP_CLIENT_ID as string)
    : (COMPANION_CLIENT_ID as string)
}

console.log('getClientId', getClientId())

export const getRedirectUri = () => {
  const isApp = getIsApp()

  return `${window.location.origin}/${
    isApp ? 'callbackSignInApp' : 'callbackSignIn'
  }`
}
